module.exports = __webpack_public_path__ + "static/media/youtube.cb17044e.png";